import React, { useState, useEffect } from 'react';
import { CheckCircleOutlined, ErrorOutlined, WarningAmberOutlined, InfoOutlined, CloseOutlined } from '@mui/icons-material';
import './Toast.css';

const ICONS = {
  success: <CheckCircleOutlined />,
  error: <ErrorOutlined />,
  warning: <WarningAmberOutlined />,
  info: <InfoOutlined />,
};

let toastId = 0;
let addToastCallback = null;

export const showToast = (message, type = 'info') => {
  if (addToastCallback) {
    addToastCallback({ id: toastId++, message, type });
  }
};

function ToastItem({ id, message, type, onRemove }) {
  useEffect(() => {
    const timer = setTimeout(() => onRemove(id), 6000);
    return () => clearTimeout(timer);
  }, [id, onRemove]);

  return (
    <div className={`toast toast-${type}`}>
      <span className="toast-icon">{ICONS[type]}</span>
      <span className="toast-msg">{message}</span>
      <button className="toast-x" onClick={() => onRemove(id)}>
        <CloseOutlined fontSize="small" />
      </button>
    </div>
  );
}

export default function Toast() {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    addToastCallback = (toast) => {
      setToasts(prev => [...prev, toast]);
    };
    return () => { addToastCallback = null; };
  }, []);

  const removeToast = (id) => {
    setToasts(prev => prev.filter(t => t.id !== id));
  };

  return (
    <div className="toast-stack">
      {toasts.map(t => (
        <ToastItem key={t.id} {...t} onRemove={removeToast} />
      ))}
    </div>
  );
}